import AddPhotoAlternateOutlinedIcon from '@mui/icons-material/AddPhotoAlternateOutlined';
import { blue, grey } from '@mui/material/colors';
import { Avatar } from 'shared/mui/Avatars';
import { Box } from 'shared/mui/Box';
import { Link } from 'shared/mui/Link/Link';
import { Typography } from 'shared/mui/Typography';

import { StyledBoxTextStateWrapper } from './ImageUploader.styled';

type ImageUploaderTextStateProps = {
  handleImageClick: () => void;
};

export const ImageUploaderTextState = ({ handleImageClick }: ImageUploaderTextStateProps) => (
  <StyledBoxTextStateWrapper onClick={handleImageClick}>
    <Avatar sx={{ bgcolor: blue[50] }}>
      <AddPhotoAlternateOutlinedIcon sx={{ color: blue[700] }} />
    </Avatar>
    <Box sx={{ marginTop: '8px', display: 'flex', alignItems: 'center' }}>
      <Link sx={{ lineHeight: '28px' }}>Нажмите, чтобы загрузить</Link>
      <Typography sx={{ lineHeight: '28px', margin: '1px 0 0 4px' }} variant="subtitle1">
        или перетащите
      </Typography>
    </Box>
    <Typography sx={{ marginTop: '8px', color: grey[700] }} variant="body2">
      PNG, JPG (max. 3MB)
    </Typography>
  </StyledBoxTextStateWrapper>
);
